enum CardType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export default CardType;
